export const StorageKey = {
  LOCALE: 'langugage',
  LOGOUT_STATE: 'logout',
  LOGIN_STATE: 'login',
  LOGGED_OFF: 'loggedOff',
  USER_ACTION_TIME:"userActionTime",
  USER_PREFERRED_TIMEOUT:"userPreferredTimeout"
};